import React, { useEffect, useState } from "react";
import { ErrorType } from "@components/global/new/Error/Error";
import { useToasts } from "@utils/hooks/useToasts";
import { CreateUserRequest } from "@services/createUser";
import { getFormValue, isEmptyForm } from "@utils/getFormValue";
import { generatePassword } from "@utils/generatePassword";
import { makeNotifs } from "@utils/makeNotifs";
import useApiRequests from "@services/http/useApiRequest";
import { UserRole } from "@services/http/responses/AccountResponse";
import { useIntl } from "react-intl";
import { dev } from "@utils/dev";

interface FormValues {
  [key: string]: any;
}

interface Elems extends HTMLFormControlsCollection, FormValues { }

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

interface AddClientControlI {
  readonly generated?: string;
  readonly errorField?: ErrorType;

  onGenerate(): void;
  onSubmit(e: React.FormEvent<MyForm>): void;
}

export const useAddClientControl = (
  handleClose: () => void
) => {
  const { formatMessage } = useIntl();
  const notifs = makeNotifs();
  const requests = useApiRequests();
  const { success } = useToasts();
  const [errorField, setErrorField] = useState<ErrorType>();
  const [generated, setGenerated] = useState<string>();
  const [roles, setRoles] = useState<{ value: string, label: string }[]>(() => {
    return Object.entries(UserRole)
      .filter(([key, value]) => value !== UserRole.Moder && value !== UserRole.Unknown)
      .map(([key, value]) => ({
        value: value,
        label: formatMessage({ id: `roles.${value}` }),
      }));
  });

  const onSubmit = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    const elems = e.currentTarget.elements;

    const formValues = getFormValue(elems) as FormValues;
    //dev.logt("formValues", "formValues", formValues);
    if (isEmptyForm(formValues, { cb: setErrorField })) {
      console.log("Form is empty", formValues);
      return;
    }
    const response = await requests.enqueue(
      new CreateUserRequest(formValues.email, formValues.password, formValues.role)
    );
    if (!response) return;
    success(notifs.ok.user_created);
    handleClose();
  };

  const onGenerate = () => {
    const gen = generatePassword();
    setGenerated(gen);
  };

  useEffect(() => {
    onGenerate();
  }, []);

  return {
    generated,
    errorField,
    roles,
    onGenerate,
    onSubmit,
  };
};
